<mat-card class="curtains">
  <div class="potential-breach-of-code-header secondary-icon">
    <h5>Potential Breach of Code</h5>
    <div class="customer-panel">
      <button matIconButton (click)="confirmDeletePotentialBreachOfCode()">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
  <mat-card-content>
    <form [formGroup]="potentialBreachOfCodeForm">
      <div class="field-rows first-row">
        <mat-form-field class="inputField">
          <mat-label>Feedback raised by</mat-label>
          <input matInput autocomplete="off" formControlName="raisedBy" maxlength="128" required />
          @if (raisedBy.invalid) {
            <mat-error>Feedback raised is <strong>required</strong></mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Date of breach</mat-label>
          <input
            (keypress)="dateInputHelper.restrictDateInput($event)"
            [matDatepicker]="dateOfIncidentDatePicker"
            required
            formControlName="dateOfIncident"
            matInput />
          <mat-datepicker-toggle [for]="dateOfIncidentDatePicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #dateOfIncidentDatePicker></mat-datepicker>
          @if (dateOfIncident.enabled) {
            <mat-hint>Date format DD/MM/YYYY</mat-hint>
          }
          @if (dateOfIncident.hasError('matDatepickerParse')) {
            <mat-error> The date format is <strong>DD/MM/YYYY</strong> </mat-error>
          }
          @if (dateOfIncident.hasError('required') && !dateOfIncident.hasError('matDatepickerParse')) {
            <mat-error> Date of breach is <strong>required</strong> </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Date discovered</mat-label>
          <input
            (keypress)="dateInputHelper.restrictDateInput($event)"
            [matDatepicker]="dateDiscoveredDatePicker"
            required
            formControlName="dateDiscovered"
            matInput />
          <mat-datepicker-toggle [for]="dateDiscoveredDatePicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #dateDiscoveredDatePicker></mat-datepicker>
          @if (dateDiscovered.enabled) {
            <mat-hint>Date format DD/MM/YYYY</mat-hint>
          }
          @if (dateDiscovered.hasError('matDatepickerParse')) {
            <mat-error> The date format is <strong>DD/MM/YYYY</strong> </mat-error>
          }
          @if (dateDiscovered.hasError('required') && !dateDiscovered.hasError('matDatepickerParse')) {
            <mat-error> Date discovered is <strong>required</strong> </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="field-rows second-row">
        <mat-form-field>
          <mat-label>Part of the Code</mat-label>
          <mat-select formControlName="partOfCode" required>
            @for (part of partOfCodeEnum | keyvalue; track part) {
              <mat-option [value]="part.key">
                <span>{{ part.value }}</span>
              </mat-option>
            }
          </mat-select>
          @if (partOfCode.invalid) {
            <mat-error>Part of the code is <strong>required</strong></mat-error>
          }
        </mat-form-field>
        <mat-form-field class="inputField">
          <mat-label>Paragraph</mat-label>
          <input matInput autocomplete="off" formControlName="codeOfPracticeParagraph" maxlength="128" required />
          @if (codeOfPracticeParagraph.invalid) {
            <mat-error>Part of the code is <strong>required</strong></mat-error>
          }
        </mat-form-field>
      </div>
      <div>
        <div class="body-2 code-practice">
          Based on the
          <a
            href="https://insurancecode.org.au/app/uploads/2023/10/GICOP_1_Oct_2023.pdf"
            rel="noopener"
            target="_blank">
            General Insurance code of practice 2020
          </a>
        </div>
        <mat-form-field>
          <mat-label>Description of potential breach</mat-label>
          <textarea
            matInput
            autocomplete="off"
            formControlName="description"
            maxlength="65535"
            cdkTextareaAutosize="true"
            cdkAutosizeMinRows="1"
            required></textarea>
          @if (description.invalid) {
            <mat-error>Description of potential breach is <strong>required</strong></mat-error>
          }
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>
</mat-card>
